import { connect } from 'react-redux';

import { getMaxArea, getMinArea } from '../../../../browser/fast/fast_filters';
import { IAppState, Dispatch } from '../../../common/state';
import { changeMaxArea, changeMinArea } from '../../state/advanced/area';
import { Area } from './index';

export const AreaContainer = connect(
  (state: IAppState) => {
    return {
      minArea: getMinArea(state),
      maxArea: getMaxArea(state),
    };
  },
  (dispatch: Dispatch) => ({
    onMinAreaChanged: (minArea: number | undefined) => {
      dispatch(changeMinArea('total_area', minArea, false));
    },
    onMaxAreaChanged: (maxArea: number | undefined) => {
      dispatch(changeMaxArea('total_area', maxArea, false));
    },
  }),
)(Area);
